// extracted by mini-css-extract-plugin
export default {"desktopMinWidth":"1024","mobileMaxWidth":"700","mobileMaxHeightLandscape":"480","zIndexModal":"3000"};